import { render, staticRenderFns } from "./confirmEmail.vue?vue&type=template&id=cf808dfa&lang=pug"
import script from "./confirmEmail.vue?vue&type=script&lang=js"
export * from "./confirmEmail.vue?vue&type=script&lang=js"
import style0 from "./confirmEmail.vue?vue&type=style&index=0&id=cf808dfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports